/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AppCrehanaFaqEnum {
  B2B_CLASSROOM = "B2B_CLASSROOM",
  B2B_DETAIL = "B2B_DETAIL",
  B2B_LANDING = "B2B_LANDING",
  COURSE_DETAIL = "COURSE_DETAIL",
  DEGREE_DETAIL = "DEGREE_DETAIL",
  MARATHON_LANDING = "MARATHON_LANDING",
  MEMBERSHIP_DETAIL = "MEMBERSHIP_DETAIL",
}

export enum BannerIdentifier {
  ALL_MEMBERSHIPS = "ALL_MEMBERSHIPS",
  EXPIRE_MEMBERSHIP = "EXPIRE_MEMBERSHIP",
  MEMBERSHIP_LANDING = "MEMBERSHIP_LANDING",
  NEW_USER = "NEW_USER",
  REFER_FRIEND = "REFER_FRIEND",
  REMINDER_SUBSCRIPTION = "REMINDER_SUBSCRIPTION",
  RENOVATE_MEMBERSHIP = "RENOVATE_MEMBERSHIP",
  SHOPPING_CART = "SHOPPING_CART",
}

export enum BlockTypeEnum {
  BLOCK_FILE = "BLOCK_FILE",
  BLOCK_HEADING = "BLOCK_HEADING",
  BLOCK_IMAGE = "BLOCK_IMAGE",
  BLOCK_PARAGRAPH = "BLOCK_PARAGRAPH",
  BLOCK_SUBHEADING = "BLOCK_SUBHEADING",
  BLOCK_VIDEO = "BLOCK_VIDEO",
}

export enum ClaimTypeEnum {
  QUEJA = "QUEJA",
  RECLAMO = "RECLAMO",
}

export enum ContactSourceEnum {
  SOURCE_CHECKOUT = "SOURCE_CHECKOUT",
  SOURCE_DEGREE = "SOURCE_DEGREE",
  SOURCE_MEMBERSHIP_LANDING = "SOURCE_MEMBERSHIP_LANDING",
  SOURCE_ORGANIC = "SOURCE_ORGANIC",
  SOURCE_PRE_CHECKOUT = "SOURCE_PRE_CHECKOUT",
  SOURCE_PROJECT_CREATION = "SOURCE_PROJECT_CREATION",
  SOURCE_STUDENT_MEMBERSHIP_LANDING = "SOURCE_STUDENT_MEMBERSHIP_LANDING",
  SOURCE_TEMPORAL_ACCESS_LANDING = "SOURCE_TEMPORAL_ACCESS_LANDING",
  SOURCE_TRACK_LANDING = "SOURCE_TRACK_LANDING",
}

export enum CoursePromoVideoProvider {
  CREHANA = "CREHANA",
  NONE = "NONE",
  VIMEO = "VIMEO",
  WISTIA = "WISTIA",
}

export enum CourseVideoTrailerSourceVideoSourceType {
  HLSV3 = "HLSV3",
  HLSV4 = "HLSV4",
  MP3 = "MP3",
  MP4 = "MP4",
  NONE = "NONE",
}

export enum DegreeLearningCourseDetailProjectTypeEnum {
  PROJECT_TYPE_OPTIONAL = "PROJECT_TYPE_OPTIONAL",
  PROJECT_TYPE_REQUIRED = "PROJECT_TYPE_REQUIRED",
}

export enum DegreeLearningEventScheduleTargetEnum {
  TARGET_COMPLEMENTARY_SESSION = "TARGET_COMPLEMENTARY_SESSION",
  TARGET_COUNSELLING = "TARGET_COUNSELLING",
  TARGET_KICKOFF = "TARGET_KICKOFF",
}

export enum DegreeSyllabusStatusEnum {
  STATUS_CLOSURE = "STATUS_CLOSURE",
  STATUS_FINISHED = "STATUS_FINISHED",
  STATUS_ONBOARDING = "STATUS_ONBOARDING",
  STATUS_PROGRESS = "STATUS_PROGRESS",
  STATUS_SALE = "STATUS_SALE",
}

export enum DocumentTypeClaimEnum {
  CE = "CE",
  DNI = "DNI",
  PASAPORTE = "PASAPORTE",
}

export enum EnrollmentTypeEnum {
  ENROLLMENT_B2B = "ENROLLMENT_B2B",
  ENROLLMENT_DEGREE = "ENROLLMENT_DEGREE",
  ENROLLMENT_FREE = "ENROLLMENT_FREE",
  ENROLLMENT_FREEMIUM = "ENROLLMENT_FREEMIUM",
  ENROLLMENT_FREE_MEMBERSHIP = "ENROLLMENT_FREE_MEMBERSHIP",
  ENROLLMENT_GITCARD = "ENROLLMENT_GITCARD",
  ENROLLMENT_MEMBERSHIP = "ENROLLMENT_MEMBERSHIP",
  ENROLLMENT_MENTOR = "ENROLLMENT_MENTOR",
  ENROLLMENT_PAID = "ENROLLMENT_PAID",
  ENROLLMENT_PROFESSOR = "ENROLLMENT_PROFESSOR",
  ENROLLMENT_STAFF = "ENROLLMENT_STAFF",
  ENROLLMENT_TEMPORAL_ACCESS = "ENROLLMENT_TEMPORAL_ACCESS",
}

export enum LanguageEnum {
  LANGUAGE_EN = "LANGUAGE_EN",
  LANGUAGE_ES = "LANGUAGE_ES",
  LANGUAGE_PT = "LANGUAGE_PT",
}

export enum MembershipTypeMethod {
  A_1 = "A_1",
  A_2 = "A_2",
}

export enum MembershipTypeTag {
  BECADO = "BECADO",
  FAMILIAR = "FAMILIAR",
  ONG_BECADO = "ONG_BECADO",
  ORGANIZATION = "ORGANIZATION",
  PLUS = "PLUS",
  PREMIUM = "PREMIUM",
  PREMIUM_DUO = "PREMIUM_DUO",
  PREMIUM_STUDENT = "PREMIUM_STUDENT",
  PROFESIONAL = "PROFESIONAL",
  UNIVERSITY_SCHOLARSHIP = "UNIVERSITY_SCHOLARSHIP",
}

export enum MentorStatusEnum {
  STATUS_AVAILABLE = "STATUS_AVAILABLE",
  STATUS_TEMPORARY_SUSPENSION = "STATUS_TEMPORARY_SUSPENSION",
  STATUS_UNSUBSCRIBED = "STATUS_UNSUBSCRIBED",
  STATUS_VACATIONS = "STATUS_VACATIONS",
}

export enum MentorTypeEnum {
  MENTOR_COMPANIES = "MENTOR_COMPANIES",
  MENTOR_DEGREES = "MENTOR_DEGREES",
  MENTOR_PREMIUM = "MENTOR_PREMIUM",
  MENTOR_STAR = "MENTOR_STAR",
  MENTOR_SUPPORT = "MENTOR_SUPPORT",
}

export enum MyUserTypeDocument {
  DNI = "DNI",
  FOREIGNER_CARD = "FOREIGNER_CARD",
  PASSPORT = "PASSPORT",
}

export enum ProjectOrderByEnum {
  ORDER_BY_DATE = "ORDER_BY_DATE",
  ORDER_BY_SUBCATEGORY = "ORDER_BY_SUBCATEGORY",
  ORDER_BY_USER = "ORDER_BY_USER",
}

export enum ProjectParticipationCertificateEnum {
  CERTIFIED = "CERTIFIED",
  DRAFT = "DRAFT",
  PUBLISH = "PUBLISH",
}

export enum ProjectPrivacyB2BEnum {
  PROJECT_PRIVACY_ONLY_ORGANIZATION = "PROJECT_PRIVACY_ONLY_ORGANIZATION",
  PROJECT_PRIVACY_ONLY_USER = "PROJECT_PRIVACY_ONLY_USER",
}

export enum ProjectPrivacyEnum {
  PRIVACY_ALL_USER = "PRIVACY_ALL_USER",
  PRIVACY_COMMUNITY = "PRIVACY_COMMUNITY",
  PRIVACY_ONLY_USER = "PRIVACY_ONLY_USER",
}

export enum ProjectStateEnum {
  CERTIFIED = "CERTIFIED",
  DRAFT = "DRAFT",
  FINISHED = "FINISHED",
  OBSERVED = "OBSERVED",
  PUBLISHED = "PUBLISHED",
}

export enum ProjectUploadValidationEnum {
  B2B_CLASSROOM_COURSE = "B2B_CLASSROOM_COURSE",
  B2B_DEMO = "B2B_DEMO",
  B2B_NO_PROJECT = "B2B_NO_PROJECT",
  TEMPORAL_ACCESS = "TEMPORAL_ACCESS",
  UNIVERSITY_SCHOLARSHIP = "UNIVERSITY_SCHOLARSHIP",
}

export enum ProjectValidationGroupEnum {
  DEFAULT_VALIDATION_GROUP = "DEFAULT_VALIDATION_GROUP",
  VALIDATION_GROUP_FOUR = "VALIDATION_GROUP_FOUR",
  VALIDATION_GROUP_ONE = "VALIDATION_GROUP_ONE",
  VALIDATION_GROUP_THREE = "VALIDATION_GROUP_THREE",
  VALIDATION_GROUP_TWO = "VALIDATION_GROUP_TWO",
}

export enum PusherTargetEnum {
  INBOX = "INBOX",
  LIVE = "LIVE",
}

export enum ServiceCategoryClaimEnum {
  CURSO = "CURSO",
  MEMBRESIA = "MEMBRESIA",
  OTROS = "OTROS",
  PACK = "PACK",
}

export enum ServiceTypeClaimEnum {
  SERVICIO = "SERVICIO",
}

export enum StatusProjectEnum {
  CERTIFIED = "CERTIFIED",
  DRAFT = "DRAFT",
  FINISHED = "FINISHED",
  OBSERVED = "OBSERVED",
  PUBLISHED = "PUBLISHED",
}

export enum StudyPlanFrequencyEnum {
  FREQUENCY_ALL = "FREQUENCY_ALL",
  FREQUENCY_FIVE = "FREQUENCY_FIVE",
  FREQUENCY_ONE = "FREQUENCY_ONE",
  FREQUENCY_THREE = "FREQUENCY_THREE",
  FREQUENCY_TWO = "FREQUENCY_TWO",
}

export enum StudyPlanTargetEnum {
  TARGET_CHILL = "TARGET_CHILL",
  TARGET_INTENSIVE = "TARGET_INTENSIVE",
  TARGET_REGULAR = "TARGET_REGULAR",
}

export enum UserDegreeSegmentationEnum {
  ACTIVATED_DEGREE_SEGMENTATION = "ACTIVATED_DEGREE_SEGMENTATION",
  EXPIRED_DEGREE_SEGMENTATION = "EXPIRED_DEGREE_SEGMENTATION",
}

export enum UserSettingsPlayerAudioLanguageCode {
  EN = "EN",
  ES = "ES",
  PT = "PT",
}

export enum UserSettingsPlayerSubtitleLanguageCode {
  EN = "EN",
  ES = "ES",
  PT = "PT",
}

export enum UserTagEnum {
  B2B = "B2B",
  COLLEGE_SCHOLARSHIP = "COLLEGE_SCHOLARSHIP",
  MENTOR = "MENTOR",
  MENTOR_STAR = "MENTOR_STAR",
  PLUS = "PLUS",
  PREMIUM = "PREMIUM",
  PREMIUM_STUDENT = "PREMIUM_STUDENT",
  PROFESSIONAL = "PROFESSIONAL",
  PROFESSOR = "PROFESSOR",
  SCHOLARSHIP = "SCHOLARSHIP",
  STAFF = "STAFF",
}

export enum VideoSpeedEnum {
  SPEED_0_25 = "SPEED_0_25",
  SPEED_0_5 = "SPEED_0_5",
  SPEED_0_75 = "SPEED_0_75",
  SPEED_1 = "SPEED_1",
  SPEED_1_25 = "SPEED_1_25",
  SPEED_1_5 = "SPEED_1_5",
  SPEED_1_75 = "SPEED_1_75",
  SPEED_2 = "SPEED_2",
}

export interface BlockInput {
  id?: string | null;
  type?: BlockTypeEnum | null;
  value?: string | null;
  filename?: string | null;
  contentType?: string | null;
  size?: string | null;
  updatedAt?: string | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
